import { render, staticRenderFns } from "./keyword-dialog.vue?vue&type=template&id=2d030ec7&scoped=true"
import script from "./keyword-dialog.vue?vue&type=script&lang=js"
export * from "./keyword-dialog.vue?vue&type=script&lang=js"
import style0 from "./keyword-dialog.vue?vue&type=style&index=0&id=2d030ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d030ec7",
  null
  
)

export default component.exports